export enum StrainTranslationEnum {
    NO_TRANSLATIONS = 10,
    TRANSLATIONS_ENABLED = 20,
    TRANSLATIONS_DISABLED = 30,
}
